import { ResourcesConfig } from 'aws-amplify';
import { environment } from './environments/environment';

export const awsconfig: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolClientId: environment.cognito.userPoolWebClientId,
            userPoolId: environment.cognito.userPoolId,
            identityPoolId: environment.cognito.identityPoolId,
            loginWith: {
                username: true,
                email: false,
                phone: false,
            },
            passwordFormat: {
                minLength: 8,
                requireLowercase: true,
                requireUppercase: true,
                requireNumbers: true,
                requireSpecialCharacters: true,
            }
        }
    }
};
